var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkOperatorAssurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FE8839;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Internet_Server"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.5,196.4H56.7c-21.3,0-38.6,17.3-38.7,38.7v201.1c0,21.3,17.3,38.6,38.7,38.7h92.8 c21.3,0,38.6-17.3,38.7-38.7V235.1C188.1,213.8,170.8,196.5,149.5,196.4z M33.5,428.4V242.8h139.2v185.6H33.5z M56.7,211.9h92.8 c9.8,0,18.5,6.2,21.8,15.5H34.9C38.2,218.1,46.9,211.9,56.7,211.9z M149.5,459.4H56.7c-9.8,0-18.5-6.2-21.8-15.5h136.4 C168,453.1,159.3,459.3,149.5,459.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.7,139.4c9.6-12.6,24.5-20.1,40.4-20.3c15.9,0.2,30.8,7.7,40.4,20.3c2.7,3.3,7.6,3.8,10.9,1.1 c3.3-2.7,3.8-7.6,1.1-10.9c-12.6-16.2-31.9-25.8-52.4-26.1c-20.5,0.3-39.8,9.9-52.4,26.1c-2.7,3.3-2.2,8.2,1.1,10.9 S60,142.8,62.7,139.4L62.7,139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.9,162.3c2.5,3.5,7.3,4.3,10.8,1.8c3.5-2.5,4.3-7.3,1.8-10.8c-7.4-11.3-19.9-18.2-33.3-18.7 c-13.5,0.5-25.9,7.4-33.3,18.7c-2.5,3.5-1.7,8.3,1.8,10.8c3.5,2.5,8.3,1.7,10.8-1.8c4.5-7.2,12.3-11.8,20.8-12.3 C111.6,150.5,119.3,155.1,123.9,162.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103,165.5c-4.3,0-7.7,3.5-7.7,7.8c0,4.3,3.5,7.7,7.8,7.7c4.3,0,7.7-3.5,7.7-7.8 C110.8,169,107.3,165.5,103,165.5L103,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,274.4c-2.9-1.2-6.2-0.5-8.4,1.7L51.2,307c-3,3.1-2.9,8,0.2,10.9c3,2.9,7.7,2.9,10.7,0l17.7-17.7v89.6 c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7V281.5C95.3,278.4,93.5,275.5,90.6,274.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.9,353.4c-3-3-7.9-3-10.9,0l-17.7,17.7v-89.6c0-4.3-3.5-7.7-7.7-7.7s-7.7,3.5-7.7,7.7v108.3 c0,3.1,1.9,5.9,4.8,7.1c2.9,1.2,6.2,0.5,8.4-1.7l30.9-30.9C158,361.3,158,356.4,154.9,353.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.5,119.1c8.5,0,15.5-6.9,15.5-15.5V41.8c0-8.5-6.9-15.5-15.5-15.5v-7.7c0-4.3-3.5-7.7-7.7-7.7 s-7.7,3.5-7.7,7.7v7.7H234.5v-7.7c0-4.3-3.5-7.7-7.7-7.7s-7.7,3.5-7.7,7.7v7.7c-8.5,0-15.5,6.9-15.5,15.5v61.9 c0,8.5,6.9,15.5,15.5,15.5h15.5v15.5h-15.5c-8.5,0-15.5,6.9-15.5,15.5v61.9c0,8.5,6.9,15.5,15.5,15.5h15.5v15.5h-15.5 c-8.5,0-15.5,6.9-15.5,15.5v61.9c0,8.5,6.9,15.5,15.5,15.5h15.5v15.5h-15.5c-8.5,0-15.5,6.9-15.5,15.5v61.9 c0,8.5,6.9,15.5,15.5,15.5v23.2c0,4.3,3.5,7.7,7.7,7.7h30.9c4.3,0,7.7-3.5,7.7-7.7v-23.2h154.7v23.2c0,4.3,3.5,7.7,7.7,7.7h30.9 c4.3,0,7.7-3.5,7.7-7.7v-23.2c8.5,0,15.5-6.9,15.5-15.5v-61.9c0-8.5-6.9-15.5-15.5-15.5h-15.5v-15.5h15.5c8.5,0,15.5-6.9,15.5-15.5 v-61.9c0-8.5-6.9-15.5-15.5-15.5h-15.5v-15.5h15.5c8.5,0,15.5-6.9,15.5-15.5V150c0-8.5-6.9-15.5-15.5-15.5h-15.5v-15.5H466.5z  M219.1,41.8h247.5v61.9H219.1V41.8z M250,459.4h-15.5v-15.5H250V459.4z M451.1,459.4h-15.5v-15.5h15.5V459.4z M466.5,428.4H219.1 v-61.9h247.5V428.4z M435.6,351.1H250v-15.5h185.6V351.1z M466.5,320.2H219.1v-61.9h247.5V320.2z M435.6,242.8H250v-15.5h185.6 V242.8z M466.5,211.9H219.1V150h247.5V211.9z M435.6,134.6H250v-15.5h185.6V134.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M443.3,80.4c4.3,0,7.7-3.5,7.7-7.7c0-4.3-3.5-7.7-7.7-7.7h-0.1c-4.3,0-7.7,3.5-7.7,7.8 C435.6,77,439.1,80.4,443.3,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.1,80.4c4.3,0,7.7-3.5,7.7-7.7c0-4.3-3.5-7.7-7.7-7.7h-0.1c-4.3,0-7.7,3.5-7.7,7.8 C412.4,77,415.9,80.4,420.1,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.9,80.4c4.3,0,7.7-3.5,7.7-7.7c0-4.3-3.5-7.7-7.7-7.7h-0.1c-4.3,0-7.7,3.5-7.7,7.8 C389.2,77,392.7,80.4,396.9,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,80.4V65c0-4.3-3.5-7.7-7.7-7.7s-7.7,3.5-7.7,7.7v15.5c0,4.3,3.5,7.7,7.7,7.7S250,84.7,250,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.2,88.2c4.3,0,7.7-3.5,7.7-7.7V65c0-4.3-3.5-7.7-7.7-7.7s-7.7,3.5-7.7,7.7v15.5 C265.5,84.7,268.9,88.2,273.2,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.1,88.2c4.3,0,7.7-3.5,7.7-7.7V65c0-4.3-3.5-7.7-7.7-7.7s-7.7,3.5-7.7,7.7v15.5 C296.4,84.7,299.9,88.2,304.1,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.6,181c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7s-3.5-7.7-7.7-7.7h-0.1C439,173.3,435.6,176.7,435.6,181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.1,173.2L420.1,173.2c-4.3,0-7.8,3.5-7.8,7.8c0,4.3,3.5,7.7,7.8,7.7c4.3,0,7.7-3.5,7.7-7.8 C427.8,176.7,424.4,173.2,420.1,173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.9,173.2L396.9,173.2c-4.3,0-7.8,3.5-7.8,7.8c0,4.3,3.5,7.7,7.8,7.7c4.3,0,7.7-3.5,7.7-7.8 C404.6,176.7,401.2,173.2,396.9,173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.3,165.5c-4.3,0-7.7,3.5-7.7,7.7v15.5c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7v-15.5 C250,169,246.5,165.5,242.3,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.2,165.5c-4.3,0-7.7,3.5-7.7,7.7v15.5c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7v-15.5 C280.9,169,277.5,165.5,273.2,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.1,165.5c-4.3,0-7.7,3.5-7.7,7.7v15.5c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7v-15.5 C311.9,169,308.4,165.5,304.1,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.6,289.2c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7s-3.5-7.7-7.7-7.7h-0.1C439,281.5,435.6,285,435.6,289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.1,281.5L420.1,281.5c-4.3,0-7.8,3.5-7.8,7.8c0,4.3,3.5,7.7,7.8,7.7c4.3,0,7.7-3.5,7.7-7.8 C427.8,285,424.4,281.5,420.1,281.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.9,281.5L396.9,281.5c-4.3,0-7.8,3.5-7.8,7.8c0,4.3,3.5,7.7,7.8,7.7c4.3,0,7.7-3.5,7.7-7.8 C404.6,285,401.2,281.5,396.9,281.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.3,273.8c-4.3,0-7.7,3.5-7.7,7.7V297c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7v-15.5 C250,277.2,246.5,273.8,242.3,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.2,273.8c-4.3,0-7.7,3.5-7.7,7.7V297c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7v-15.5 C280.9,277.2,277.5,273.8,273.2,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.1,273.8c-4.3,0-7.7,3.5-7.7,7.7V297c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7v-15.5 C311.9,277.2,308.4,273.8,304.1,273.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.6,397.5c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7s-3.5-7.7-7.7-7.7h-0.1C439,389.8,435.6,393.3,435.6,397.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.1,389.8L420.1,389.8c-4.3,0-7.8,3.5-7.8,7.8c0,4.3,3.5,7.7,7.8,7.7c4.3,0,7.7-3.5,7.7-7.8 C427.8,393.2,424.4,389.8,420.1,389.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.9,389.8L396.9,389.8c-4.3,0-7.8,3.5-7.8,7.8c0,4.3,3.5,7.7,7.8,7.7c4.3,0,7.7-3.5,7.7-7.8 C404.6,393.2,401.2,389.8,396.9,389.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.3,382c-4.3,0-7.7,3.5-7.7,7.7v15.5c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7v-15.5 C250,385.5,246.5,382,242.3,382z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M273.2,382c-4.3,0-7.7,3.5-7.7,7.7v15.5c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7v-15.5 C280.9,385.5,277.5,382,273.2,382z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.1,382c-4.3,0-7.7,3.5-7.7,7.7v15.5c0,4.3,3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7v-15.5 C311.9,385.5,308.4,382,304.1,382z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkOperatorAssurance);
export default __webpack_public_path__ + "static/media/Network Operator Assurance.465214ed5afadf9b3a668e2865846be5.svg";
export { ForwardRef as ReactComponent };